export enum WALL_SLOT_TYPE {
  CLASSIC = "CLASSIC",
  PARTNER = "PARTNER",
  LAST_MINUTE = "LAST_MINUTE",
  STAY_REQUEST = "STAY_REQUEST",
  PROMO = "PROMO",
  OFFER = "OFFER",
  SOCIAL = "SOCIAL",
  HERO = "HERO",
}

export type WallSlotClassic = {
  query: object;
  limit?: number;
  sort?: object;
  scroll?: boolean;
};
export type WallSlotPartners = {
  query: object;
  hidePartnerModal?: boolean;
  limit?: number;
  sort?: object;
};
type WallSlotStayRequest = {};
type WallSlotSocial = {};

export type WallSlotLastMinute = {
  query: object;
  sort?: object;
  limit?: number;
  action?: () => void;
};

export type WallSlotPromo = {
  title: string;
  subtitle: string;
  background: string;
  logo?: string;
  action?: string;
  actionLabel?: string;
  newTab?: boolean;
};
export type WallSlotOffer = {
  query: object;
  limit?: number;
  sort?: object;
  action?: () => void;
};

export type WallSlotTypePayload =
  | { type: WALL_SLOT_TYPE.CLASSIC; payload: WallSlotClassic }
  | { type: WALL_SLOT_TYPE.PARTNER; payload: WallSlotPartners }
  | { type: WALL_SLOT_TYPE.LAST_MINUTE; payload: WallSlotLastMinute }
  | { type: WALL_SLOT_TYPE.STAY_REQUEST; payload: WallSlotStayRequest }
  | { type: WALL_SLOT_TYPE.PROMO; payload: WallSlotPromo }
  | { type: WALL_SLOT_TYPE.OFFER; payload: WallSlotOffer }
  | { type: WALL_SLOT_TYPE.SOCIAL; payload: WallSlotSocial }
  | { type: WALL_SLOT_TYPE.HERO; payload: { action?: () => void } };

export interface iWallSlot {
  title: string;
  subtitle?: string;

  config: WallSlotTypePayload;
}
